module.exports = __webpack_public_path__ + "static/img/idual_bg_5@2x.d63fd47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/idual/idual_bg_5@2x.jpg
// module id = 124
// module chunks = 0